import { useUserContext } from "./useUserContext";
import { createAxiosApi } from "../Helpers/axiosApiHelper";
import {
	useState,
	useEffect
} from "react";

export function useUnitAppropriationService(config) {
	const user = useUserContext(config);
	const [service, setService] = useState(() => {
		return createUnitAppropriationService(user, config);
	});

	useEffect(() => {
		setService(createUnitAppropriationService(user, config));
	}, [user.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

	return service;
}

function createUnitAppropriationService(user, config) {
	const api = createAxiosApi("", user, config);

	function getAll(handleResponse, handleError) {
		api.get("UnitAppropriations/")
			.then(handleResponse)
			.catch(handleError);
	}

	function getById(unitAppropriationId, handleResponse, handleError) {
		api.get(`UnitAppropriations/${unitAppropriationId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function create(unitAppropriation, handleResponse, handleError) {
		api.post("UnitAppropriations/", unitAppropriation)
			.then(handleResponse)
			.catch(handleError);
	}

	function update(unitAppropriationId, unitAppropriation, handleResponse, handleError) {
		api.put(`UnitAppropriations/${unitAppropriationId}`, unitAppropriation)
			.then(handleResponse)
			.catch(handleError);
	}

	function deleteItem(unitAppropriationId, handleResponse, handleError) {
		api.delete(`UnitAppropriations/${unitAppropriationId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function importItems(unitAppropriations, handleResponse, handleError) {
		api.post("UnitAppropriations/import", unitAppropriations)
			.then(handleResponse)
			.catch(handleError);
	}

	return {
		getAll,
		getById,
		create,
		update,
		deleteItem,
		importItems
	};
}
